import React, { useCallback, useState } from 'react';
import {
  Box,
  Button,
  Flex,
  HStack,
  Link,
  PinInput,
  PinInputField,
  Text,
} from '@chakra-ui/react';

type Props = {
  isLoading: boolean;
  errorMessage?: string;
  onSubmit: (code: string) => void;
  onBack: () => void;
};

const MFA_CODE_LENGTH = 6;

const MfaVerify: React.FC<Props> = ({
  isLoading,
  errorMessage,
  onSubmit,
  onBack,
}) => {
  const [code, setCode] = useState('');

  const handleChange = useCallback((value: string) => {
    setCode(value.replace(/\D/g, '').slice(0, MFA_CODE_LENGTH));
  }, []);

  const handleComplete = useCallback(
    (value: string) => {
      onSubmit(value);
    },
    [onSubmit],
  );

  return (
    <Box>
      <Text mb="32px" fontWeight="500" fontSize="22px" color="black">
        Verificação em dois fatores
      </Text>
      <Text fontSize="sm" color="text.300" mb="18px">
        Digite o código de 6 dígitos do seu aplicativo autenticador.
      </Text>

      <HStack spacing="12px" justifyContent="center" mb={errorMessage ? '8px' : '18px'}>
        <PinInput
          otp
          type="number"
          value={code}
          onChange={handleChange}
          onComplete={handleComplete}
          isInvalid={Boolean(errorMessage)}
          data-cy="mfa-code"
        >
          {Array.from({ length: MFA_CODE_LENGTH }, (_, index) => (
            <PinInputField
              key={index}
              w="48px"
              h="48px"
              fontSize="24px"
              fontWeight="600"
              borderRadius="8px"
              borderWidth="1px"
              borderColor="grey.500"
              bg="white"
              color="black"
              _focus={{
                borderColor: 'purple.200',
                borderWidth: '2px',
                boxShadow: 'none',
              }}
              _invalid={{
                borderColor: 'red.200',
              }}
            />
          ))}
        </PinInput>
      </HStack>

      {errorMessage && (
        <Text fontSize="sm" color="red.200" mb="18px" textAlign="center">
          {errorMessage}
        </Text>
      )}

      <Button
        w="100%"
        type="button"
        isLoading={isLoading}
        isDisabled={code.length < MFA_CODE_LENGTH}
        onClick={() => onSubmit(code)}
      >
        Verificar
      </Button>

      <Flex mt="18px" justifyContent="center">
        <Link
          as="button"
          type="button"
          fontSize="sm"
          color="ocean.200"
          onClick={onBack}
        >
          Voltar ao login
        </Link>
      </Flex>
    </Box>
  );
};

export default MfaVerify;
